<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="headTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainTitle">
            <div style="float: right">
              <el-button plain size="small" @click="toDelete()" v-if="isAssociationAdmin == 'N'">删除</el-button>
              <el-button type="primary" size="small" @click="toEdit()">编辑</el-button>
            </div>
          </div>
          <el-tabs class="elTabs" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="详情" name="0">
              <association-details></association-details>
            </el-tab-pane>
            <el-tab-pane label="校友会资讯" name="1"><association-news></association-news></el-tab-pane>
            <el-tab-pane label="校友会活动" name="2">
              <association-activitys></association-activitys>
            </el-tab-pane>
            <el-tab-pane label="校友会照片" name="3"><association-images></association-images></el-tab-pane>
            <el-tab-pane label="加入的校友" name="4">
              <association-join-list @toUserDetails="toUserDetails"></association-join-list>
            </el-tab-pane>
            <el-tab-pane label="文件系统" name="5">
              <association-file-system></association-file-system>
            </el-tab-pane>
            <el-tab-pane label="相册" name="7">
              <association-album></association-album>
            </el-tab-pane>
            <el-tab-pane label="团队" name="6" v-if="isAssociationAdmin == 'N'">
              <association-team></association-team>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import associationDetails from '@/components/association/associationDetails'
import associationNews from '@/components/association/associationNews'
import associationActivitys from '@/components/association/associationActivitys'
import associationImages from '@/components/association/associationImages'
import associationJoinList from '@/components/association/associationJoinList'
import associationFileSystem from '@/components/association/associationFileSystem'
import associationTeam from '@/components/association/associationTeam'
import associationAlbum from '@/components/association/associationAlbum'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    associationDetails,
    associationNews,
    associationActivitys,
    associationImages,
    associationJoinList,
    associationFileSystem,
    associationTeam,
    associationAlbum
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      headTitle: '校友会名称',
      activeName: localStorage.getItem('association_tab'),
      isAssociationAdmin: 'Y'
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = meunItem.name
      this.headTitle = this.$route.query.title
      this.associationAdmin()
    },
    handleClick(tab, event) {
      localStorage.setItem('association_tab', tab.name)
    },
    // 是否是校友分会长
    associationAdmin: function () {
      this.$api
        .isAssociationAdmin({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.isAssociationAdmin = data.Data.isAssociationAdmin
        })
        .catch(({ error }) => {})
    },
    // 编辑校友会
    toEdit() {
      this.$router.push({
        path: '/wxapp/association_add',
        query: {
          id: this.$route.query.id
        }
      })
    },
    // 删除校友会
    toDelete() {
      this.$confirm('是否删除此校友会?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .delAssociation({
              token: localStorage.getItem('token'),
              id: this.$route.query.id
            })
            .then(({ data }) => {
              this.$router.back(-1)
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    },
    // 查看学生详情 details
    toUserDetails(row) {
      Api.verifyApi(CApi.api_getAisInfoById, verify => {
        if (verify) {
          this.meunItem.userid = row.id;
          localStorage.setItem("meunItem", JSON.stringify(this.meunItem));
          this.$router.push({path:"/data/user-details",query:{id:row.id}});
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -30px;
  margin-left: -20px;
  margin-right: -20px;
}
.elTabs {
  margin-top: -40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/association.vue